import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "o-grid u-mar-t-2" }
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 u-form-grid-lowspace-y" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  class: "c-form-control-checkbox__label",
  for: "fahrradschutz"
}
const _hoisted_5 = {
  key: 0,
  class: "c-form-control-checkbox__label-text"
}
const _hoisted_6 = {
  key: 1,
  class: "c-form-control-checkbox__label-text"
}
const _hoisted_7 = { class: "gev19-optional-module-content" }
const _hoisted_8 = { class: "gev19-optional-module-content-icon" }
const _hoisted_9 = {
  class: "gev19-optional-module-content-text",
  style: {"display":"inline"}
}
const _hoisted_10 = { class: "c-list" }
const _hoisted_11 = {
  key: 0,
  class: "c-list__item c-list__item_icon-present"
}
const _hoisted_12 = { class: "o-grid gev19-optional-module-subform" }
const _hoisted_13 = { class: "o-grid__cell o-grid__cell--12" }
const _hoisted_14 = { class: "c-form-control" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "gev19-optional-module-premium u-text-align-right" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_sprite = _resolveComponent("icon-sprite")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 u-form-grid-nospace-y" }, [
        _createElementVNode("h2", { class: "u-form-heading unset-text-align" }, "Zusätzlich absichern")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["gev19-optional-module", {
            'gev19-optional-module--enabled': _ctx.piniaStore.state.tarifinformationen.fahrradschutz,
          }])
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: _normalizeClass([{
                'c-form-control-checkbox--disabled': _ctx.istPremiumTarif,
              }, "c-form-control-checkbox"])
            }, [
              _withDirectives(_createElementVNode("input", {
                id: "fahrradschutz",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.fahrradschutz) = $event)),
                disabled: _ctx.istPremiumTarif,
                class: "c-form-control-checkbox__input",
                "data-cy": "fahrradschutzOption",
                type: "checkbox",
                "aria-label": "Fahrradschutz Auswahl"
              }, null, 8, _hoisted_3), [
                [_vModelCheckbox, _ctx.piniaStore.state.tarifinformationen.fahrradschutz]
              ]),
              _createElementVNode("label", _hoisted_4, [
                _createVNode(_component_icon_sprite, {
                  "ist-klein": true,
                  "css-klassen": "c-form-control-checkbox__icon",
                  "icon-name": "icon-check-mark"
                }),
                (!_ctx.piniaStore.state.isMakler)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Fahrraddiebstahl (Wert Ihrer Fahrräder) "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, " Fahrraddiebstahl "))
              ]),
              _createElementVNode("span", {
                class: "gev19__contexthelp-open",
                title: "Hilfe anzeigen",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.zeigeInfo()))
              })
            ], 2),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_icon_sprite, {
                  "ist-gross": true,
                  "icon-name": "icon-bike"
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("ul", _hoisted_10, [
                  _cache[5] || (_cache[5] = _createElementVNode("li", { class: "c-list__item" }, "24h Diebstahlschutz", -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("li", { class: "c-list__item" }, "Schlosssicherung genügt", -1)),
                  (_ctx.piniaStore.state.isMakler)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_11, " 1.000 € sind bereits im Premium-Tarif enthalten "))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.fahrradschutzBetrag) = $event)),
                    disabled: !_ctx.piniaStore.state.tarifinformationen.fahrradschutz,
                    class: "chooseOptionsSelect c-form-control-select",
                    "data-cy": "fahrradschutzBetrag",
                    name: "fahrradschutzBetrag",
                    "aria-label": "Wert Fahrrad",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('change', _ctx.inputChangeHandler($event))))
                  }, _cache[7] || (_cache[7] = [
                    _createElementVNode("option", { value: 1000 }, "1.000 €", -1),
                    _createElementVNode("option", { value: 2000 }, "2.000 €", -1),
                    _createElementVNode("option", { value: 3000 }, "3.000 €", -1),
                    _createElementVNode("option", { value: 4000 }, "4.000 €", -1),
                    _createElementVNode("option", { value: 5000 }, "5.000 €", -1),
                    _createElementVNode("option", { value: 6000 }, "6.000 €", -1),
                    _createElementVNode("option", { value: 7000 }, "7.000 €", -1),
                    _createElementVNode("option", { value: 8000 }, "8.000 €", -1),
                    _createElementVNode("option", { value: 9000 }, "9.000 €", -1),
                    _createElementVNode("option", { value: 10000 }, "10.000 €", -1),
                    _createElementVNode("option", { value: 11000 }, "11.000 €", -1),
                    _createElementVNode("option", { value: 12000 }, "12.000 €", -1),
                    _createElementVNode("option", { value: 13000 }, "13.000 €", -1),
                    _createElementVNode("option", { value: 14000 }, "14.000 €", -1),
                    _createElementVNode("option", { value: 15000 }, "15.000 €", -1),
                    _createElementVNode("option", { value: 16000 }, "16.000 €", -1),
                    _createElementVNode("option", { value: 17000 }, "17.000 €", -1),
                    _createElementVNode("option", { value: 18000 }, "18.000 €", -1),
                    _createElementVNode("option", { value: 19000 }, "19.000 €", -1),
                    _createElementVNode("option", { value: 20000 }, "20.000 €", -1)
                  ]), 40, _hoisted_15), [
                    [
                      _vModelSelect,
                      _ctx.piniaStore.state.tarifinformationen.fahrradschutzBetrag,
                      void 0,
                      { number: true }
                    ]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.beitrag), 1)
          ]),
          (_ctx.modulInfo)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "gev19__contexthelp-text",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.zeigeInfo()))
              }, [
                (!_ctx.piniaStore.state.isMakler)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Mit der Fahrraddiebstahldeckung erhalten Sie einen Rund-um-die-Uhr-Diebstahlschutz für Ihre Fahrräder. Wir erwarten lediglich, dass Sie die Räder bei Nichtgebrauch mit einem verkehrsüblichen Fahrradschloss gegen Diebstahl sichern. Haben Sie mehrere Fahrräder, geben Sie für die Beitragsberechnung nur den Wert des teuersten Fahrrads an, sofern Sie alle Fahrräder einzeln mit einem Fahrradschloss sichern. "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_18, _cache[8] || (_cache[8] = [
                      _createTextVNode(" Mit der Fahrraddiebstahldeckung erhält Ihr Kunde einen Rund-um-die-Uhr-Diebstahlschutz für seine Fahrräder. Die Räder sind bei Nichtgebrauch mit einem verkehrsüblichen Fahrradschloss gegen Diebstahl sichern. Hat Ihr Kunde mehrere Fahrräder, geben Sie für die Beitragsberechnung nur den Wert des teuersten Fahrrads an, sofern alle Fahrräder einzeln mit einem Fahrradschloss gesichert werden."),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode("Im Tarif Premium sind Fahrräder bereits mit 1.000 € beitragsfrei mitversichert. ")
                    ])))
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ]))
}